module.exports = __webpack_public_path__ + "static/media/background_btn_1@2x.67852c7f.png";